// Package Imports
import { Skeleton, Space } from 'antd'

type Props = {
  /** Number of skeleton blocks to render. Default 3. */
  rows?: number
  /** Show a title placeholder above blocks. Default true. */
  withTitle?: boolean
}

/**
 * Generic page-level loading placeholder. Use for routes whose data is loading
 * via Suspense or a top-level query. Prefer over ad-hoc `<Spin />` so visual
 * rhythm stays consistent across modules.
 */
const PageSkeleton = ({ rows = 3, withTitle = true }: Props) => (
  <Space orientation="vertical" size={20} className="w-full">
    {withTitle && (
      <Skeleton.Input active size="large" style={{ width: 320, height: 32 }} />
    )}
    {Array.from({ length: rows }).map((_, i) => (
      <Skeleton key={i} active paragraph={{ rows: 3 }} />
    ))}
  </Space>
)

export default PageSkeleton
